import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PreferenceService from "../../services/preference.service";

/* ================= THUNKS ================= */

export const getPreference = createAsyncThunk(
  "preference/getPreference",
  async (params, thunkAPI) => {
    try {
      const response = await PreferenceService.getPreference(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addPreference = createAsyncThunk(
  "preference/addPreference",
  async (data, thunkAPI) => {
    try {
      const response = await PreferenceService.addPreference(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const searchProfile = createAsyncThunk(
  "preference/searchProfile",
  async (params, thunkAPI) => {
    try {
      const response = await PreferenceService.searchProfile(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getProfileById = createAsyncThunk(
  "preference/getProfileById",
  async (params, thunkAPI) => {
    try {
      const response = await PreferenceService.getProfileById(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
export const getPreferredMatches = createAsyncThunk(
  "preference/getPreferredMatches",
  async (params, thunkAPI) => {
    try {
      const response = await PreferenceService.getPreferredMatches(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const viewContact = createAsyncThunk(
  "preference/viewContact",
  async (params, thunkAPI) => {
    try {
      const response = await PreferenceService.viewContact(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

/* ================= INITIAL STATE ================= */
const initialState = {
  loading: false,
  searchLoading: false,
  profileLoading: false,
  preferredLoading: false,

  error: null,

  preferencelist: [],
  searchResults: [],
  preferredMatches: [],
  profileDetails: null,

  updateSuccess: false,
};

/* ================= SLICE ================= */

const preferenceSlice = createSlice({
  name: "preference",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- GET PREFERENCE ---------- */
      .addCase(getPreference.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPreference.fulfilled, (state, action) => {
        state.loading = false;
        state.preferencelist = action.payload?.data || [];
      })
      .addCase(getPreference.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- ADD / UPDATE PREFERENCE ---------- */
      .addCase(addPreference.pending, (state) => {
        state.loading = true;
        state.updateSuccess = false;
      })
      .addCase(addPreference.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;
        state.preferencelist = action.payload?.data || [];
      })
      .addCase(addPreference.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- GET PROFILE BY ID ---------- */
      .addCase(getProfileById.pending, (state) => {
        state.profileLoading = true;
        state.error = null;
      })
      .addCase(getProfileById.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profileDetails = action.payload?.data || null;
      })
      .addCase(getProfileById.rejected, (state, action) => {
        state.profileLoading = false;
        state.error = action.payload;
      })

      /* ---------- SEARCH PROFILES ---------- */
      .addCase(searchProfile.pending, (state) => {
        state.searchLoading = true;
        state.error = null;
      })
      .addCase(searchProfile.fulfilled, (state, action) => {
        console.log("Reducer received:", action.payload.data.length);
        state.searchLoading = false;
        state.searchResults = action.payload?.data || [];
      })
      .addCase(searchProfile.rejected, (state, action) => {
        state.searchLoading = false;
        state.error = action.payload;
      })
      /* ---------- PREFERRED MATCHES ---------- */

      /* ---------- Preferred Matches ---------- */

      .addCase(getPreferredMatches.pending, (state) => {
        state.preferredLoading = true;
        state.error = null;
      })

      .addCase(getPreferredMatches.fulfilled, (state, action) => {
        state.preferredLoading = false;

        state.preferredMatches = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
      })

      .addCase(getPreferredMatches.rejected, (state, action) => {
        state.preferredLoading = false;
        state.error = action.payload;
      })
  },
});

export const { resetUpdateStatus } = preferenceSlice.actions;
export default preferenceSlice.reducer;